import { useCallback, useEffect, useState } from 'react';
import { AccountType, GeneralLedgerTransaction } from '@ui/src';
import {
  useLazyGetCustomerGeneralLedgerTransactionQuery,
  useLazyGetCustomersAccountBalanceByIdQuery,
  useLazyGetCustomerStatementChangeLogsQuery,
} from '../../../customers/store/services/customers';

const useStatementGLTransaction = ({
  transactionId,
  transaction,
}: {
  transactionId?: string;
  transaction?: GeneralLedgerTransaction;
}) => {
  const [panelIsOpen, setPanelIsOpen] = useState(false);

  const [
    getDebitAccountBalanceById,
    { isLoading: debitBalanceIsLoading, isFetching: debitBalanceIsFetching },
  ] = useLazyGetCustomersAccountBalanceByIdQuery();
  const [
    getCreditAccountBalanceById,
    { isLoading: creditBalanceIsLoading, isFetching: creditBalanceIsFetching },
  ] = useLazyGetCustomersAccountBalanceByIdQuery();
  const [
    getTransactionChangeLogs,
    { isLoading: changeLogsIsLoading, isFetching: changeLogsIsFetching },
  ] = useLazyGetCustomerStatementChangeLogsQuery();
  const [getGeneralLedger, { isLoading, isFetching }] =
    useLazyGetCustomerGeneralLedgerTransactionQuery();

  const getTransactionChangeLogsAction = useCallback(
    (cursor?: string) => {
      getTransactionChangeLogs(
        `?take=20&entityType=GENERAL_LEDGER_TRANSACTION&entityId=${transactionId}${
          cursor ? `&cursor=${cursor}` : ''
        }`,
      );
    },
    [transactionId],
  );

  const getTransaction = useCallback((id: string) => {
    getGeneralLedger(id);
  }, []);

  useEffect(() => {
    if (!transaction && transactionId) {
      getTransaction(transactionId);
    }
  }, [getTransaction, transaction, transactionId]);

  useEffect(() => {
    if (transactionId && transaction) {
      getDebitAccountBalanceById({
        id: transaction?.debitAccountId as string,
        query: `&currencyId=${transaction?.currencyId}`,
        typeAcc: AccountType.DEBIT,
      });
      getCreditAccountBalanceById({
        id: transaction?.creditAccountId as string,
        query: `&currencyId=${transaction?.currencyId}`,
        typeAcc: AccountType.CREDIT,
      });
    }
  }, [transactionId, transaction]);

  return {
    setPanelIsOpen,
    panelIsOpen,
    isLoading,
    isFetching,
    debitBalanceIsLoading,
    debitBalanceIsFetching,
    creditBalanceIsLoading,
    creditBalanceIsFetching,
    changeLogsIsLoading,
    changeLogsIsFetching,
    getTransactionChangeLogsAction,
  };
};

export default useStatementGLTransaction;
